// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4679":"css/admin-app.6739","7417":"css/app.6739"}[chunkId] + ".css";
};